module.exports = __webpack_public_path__ + "img/en.6c9755bf.png";